import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CashierBase } from '../cashier/cashier-base/cashier-base';

@Component({
    selector: 'app-my-transaction-methods',
    templateUrl: './my-transaction-methods.component.html',
    styleUrls: ['./my-transaction-methods.component.scss'],
})
export class MyTransactionMethodsComponent extends CashierBase implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent

    public accounts: any = [];
    public confirmSection: boolean = false;
    public error = null;
    public paymentVendors: any = [];
    public selectedAccount: any;
    public onBackCallback: Function;

    constructor(
        public cashierService: CashierService,
        public config: ConfigService,
        public events: EventsService,
        public navigator: Navigator,
        public successMessageService: SuccessMessageService,
        public utils: UtilsService,
    ) {
        super();
        this.successMessageService.clearMessage();
        this.error = null;
    }

    ngOnInit(): void {
        this.onBackCallback = this.onBack.bind(this);
        this.successMessageService.clearMessage();

        this.getVendorData();
        this.onGetAccounts();
    }

    public onGetAccounts() {
        this.accounts = [];
        const allowedTypes = this.config.getConfig().FEATURE_DISPLAY_TRANSACTIONS_TYPE;

        this.cashierService.callListAccounts().subscribe((response: any) => {
            if (response && !!response.result && allowedTypes) {
                const filtered_methods = ["IDEBIT", "INSTADEBIT", "INTERAC"];
                const tempAccounts: any = response.payload.filter(item => !filtered_methods.includes(item.paymentTypeCode));

                for (let index in tempAccounts) {
                    let typeCode: string = tempAccounts[index].paymentTypeCode;
                    if (allowedTypes.includes(typeCode)) {
                        this.accounts.push(tempAccounts[index]);
                    }
                }
            }
        }, (error) => this.error = error
        );
    }

    public getVendorData() {
        this.cashierService.getActiveTypesCategories({ include_types: true }).subscribe((response: any) => {
            if (response.result) {
                let vendors = response.payload;
                this.paymentVendors = vendors;
                return;
            }
        }, error => {
            console.error("Vendor Data Error", error);
        });
    }

    public getPaymentImage(code: any): string {
        const codeOrig = code;
        if (code == 'VI') code = 'CREDIT';
        if (code == 'MC') code = 'CREDIT';
        if (code == 'AM') code = 'CREDIT';
        if (code == 'DIS') code = 'CREDIT';

        const name = this.paymentVendors.filter(link => link.code == code)[0].types.filter(linkInner => linkInner.code == codeOrig)[0].image_url;
        const imageUrl: string = `url(${this.utils.getDepositNetworkPath(name)})`;
        return imageUrl;
    }

    public onRemoveAccount(customerAccountID: string) {
        this.cashierService.callRemoveAccount(customerAccountID).subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    this.successMessageService.setMessage('Your payment method was deleted successfully.');
                    this.content.scrollToTop(10);
                }
            },
            (error) => {
                this.error = this.handleError(error);
                this.content.scrollToTop(10);
            }
        );


        return setTimeout(() => {
            this.accounts = [];
            this.onGetAccounts();
            this.confirmSection = false
        }, 1000);
    }

    public onCancel() {
        this.confirmSection = false;
        this.ngOnInit();
    }

    public onConfirmSection(account: any) {
        this.accounts = [];
        this.successMessageService.clearMessage();
        this.selectedAccount = account;
        return this.confirmSection = true;
    }

    onBack() {
        if (this.confirmSection) {
            this.onCancel();
        } else {
            this.navigator.back();
        }
    }
}